import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { Mottagningsplatstyper } from "~app/common/models/constants";
import { MottagningsplatsListRequestDTO } from "~app/common/models/lagerplats/MottagningsplatsListRequestDTO";
import { Mottagningsplats } from "~app/common/models/lagerplats/MottagningsplatsListResponseDTO";
import { FormatService } from "~app/common/services/format.service";
import { StatedataService, Volatile } from "~app/common/services/statedata.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { MottagningsplatsService } from "../../mottagningsplats.service";

@Component({
    selector: "rask-search-mottagningsplats-panel",
    templateUrl: "./search-mottagningsplats-panel.component.html",
    styleUrls: ["./search-mottagningsplats-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        SelectorComponent,
        RadiobuttonGroupComponent,
        SubmitButtonComponent,
        TranslatePipe
    ]
})
export class SearchMottagningsplatsPanelComponent implements OnInit {
    activetypes: IRadiobuttonItem[] = [
        { key: "true",
            value: "Ja" },
        { key: "false",
            value: "Nej" },
        { key: "",
            value: "Alla" }
    ];
    egenTerminalTypes: IRadiobuttonItem[] = [
        { key: "true",
            value: "Ja" },
        { key: "false",
            value: "Nej" },
        { key: "",
            value: "Alla" }
    ];
    form: UntypedFormGroup;
    mottagningsplatstyper: any[];

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("searchresult") searchresult = new EventEmitter<Mottagningsplats[]>(true);
    volatile: Volatile;

    private readonly busyService = inject(BusyService);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly formatService = inject(FormatService);
    private readonly mottagningsplatsService = inject(MottagningsplatsService);
    private readonly statedataService = inject(StatedataService);

    constructor() {
        this.volatile = this.statedataService.getVolatile();
    }

    do_search(searchParams: MottagningsplatsListRequestDTO): void {
        const query = this.mottagningsplatsService.search(searchParams);
        this.busyService.addWork(query).subscribe(res => {
            this.volatile.set("searchparams", searchParams);
            this.searchresult.emit(res.mottagningsplatsList);
        });
    }

    mottagningsplatstypValueFormatter = (item) => item?.value;

    mottagningsplatstypViewFormatter = (item) => item?.option;

    ngOnInit() {
        this.mottagningsplatstyper = Mottagningsplatstyper.Alla;

        let searchParams = this.volatile.get<MottagningsplatsListRequestDTO>("searchparams");
        if (searchParams) {
            this.do_search(searchParams);
        } else {
            searchParams = new MottagningsplatsListRequestDTO();
            searchParams.aktiv = true;
        }

        this.form = this.formBuilder.group(searchParams);
        this.form.get("aktiv").setValue(searchParams.aktiv ? "true" : "false");
        // eslint-disable-next-line sonarjs/no-nested-conditional
        const egenTerminalValue = ObjectUtils.isNullOrUndefined(searchParams.egenTerminal) ? "" : searchParams.egenTerminal ? "true" : "false";
        this.form.get("egenTerminal").setValue(egenTerminalValue);
    }

    search(): void {
        const searchParams = new MottagningsplatsListRequestDTO();
        searchParams.namn = this.form.get("namn").value;
        searchParams.egenTerminal = this.form.get("egenTerminal").value;
        searchParams.mottagningsplatstyp = this.form.get("mottagningsplatstyp").value;
        searchParams.mottagningsplatsnummer = this.form.get("mottagningsplatsnummer").value;
        searchParams.beskrivning = this.form.get("beskrivning").value;
        searchParams.ansvarigLogistiker = this.form.get("ansvarigLogistiker").value;
        searchParams.aktiv = this.formatService.stringToBoolean(this.form.get("aktiv").value);
        searchParams.egenTerminal = this.formatService.stringToBoolean(this.form.get("egenTerminal").value);

        this.do_search(searchParams);
    }
}
